"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationsDataToJSON = exports.IntegrationsDataFromJSONTyped = exports.IntegrationsDataFromJSON = exports.instanceOfIntegrationsData = exports.attributeTypeMapIntegrationsData = void 0;
exports.attributeTypeMapIntegrationsData = [
    {
        name: "externalCacheKey",
        type: "string",
    },
    {
        name: "externalFolderPath",
        type: "string",
    },
    {
        name: "externalAppKey",
        type: "string",
    },
    {
        name: "externalAppPickerSrc",
        type: "string",
    },
    {
        name: "externalAccountId",
        type: "string",
    },
    {
        name: "externalDefaultSavePath",
        type: "string",
    },
    {
        name: "externalDefaultPathEnabled",
        type: "boolean",
    },
    {
        name: "recipientsProvidedByHostPage",
        type: "boolean",
    },
    {
        name: "externalFileName",
        type: "string",
    },
];
/**
 * Check if a given object implements the IntegrationsData interface.
 */
function instanceOfIntegrationsData(value) {
    if (!("externalCacheKey" in value) || value["externalCacheKey"] === undefined)
        return false;
    if (!("externalFolderPath" in value) ||
        value["externalFolderPath"] === undefined)
        return false;
    if (!("externalAppKey" in value) || value["externalAppKey"] === undefined)
        return false;
    if (!("externalAppPickerSrc" in value) ||
        value["externalAppPickerSrc"] === undefined)
        return false;
    if (!("externalAccountId" in value) ||
        value["externalAccountId"] === undefined)
        return false;
    if (!("externalDefaultSavePath" in value) ||
        value["externalDefaultSavePath"] === undefined)
        return false;
    if (!("externalDefaultPathEnabled" in value) ||
        value["externalDefaultPathEnabled"] === undefined)
        return false;
    if (!("recipientsProvidedByHostPage" in value) ||
        value["recipientsProvidedByHostPage"] === undefined)
        return false;
    if (!("externalFileName" in value) || value["externalFileName"] === undefined)
        return false;
    return true;
}
exports.instanceOfIntegrationsData = instanceOfIntegrationsData;
function IntegrationsDataFromJSON(json) {
    return IntegrationsDataFromJSONTyped(json, false);
}
exports.IntegrationsDataFromJSON = IntegrationsDataFromJSON;
function IntegrationsDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        externalCacheKey: json["external_cache_key"],
        externalFolderPath: json["external_folder_path"],
        externalAppKey: json["external_app_key"],
        externalAppPickerSrc: json["external_app_picker_src"],
        externalAccountId: json["external_account_id"],
        externalDefaultSavePath: json["external_default_save_path"],
        externalDefaultPathEnabled: json["external_default_path_enabled"],
        recipientsProvidedByHostPage: json["recipients_provided_by_host_page"],
        externalFileName: json["external_file_name"],
    };
}
exports.IntegrationsDataFromJSONTyped = IntegrationsDataFromJSONTyped;
function IntegrationsDataToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        external_cache_key: value["externalCacheKey"],
        external_folder_path: value["externalFolderPath"],
        external_app_key: value["externalAppKey"],
        external_app_picker_src: value["externalAppPickerSrc"],
        external_account_id: value["externalAccountId"],
        external_default_save_path: value["externalDefaultSavePath"],
        external_default_path_enabled: value["externalDefaultPathEnabled"],
        recipients_provided_by_host_page: value["recipientsProvidedByHostPage"],
        external_file_name: value["externalFileName"],
    };
}
exports.IntegrationsDataToJSON = IntegrationsDataToJSON;
